module.exports = __webpack_public_path__ + "static/media/tooltips_d_010.movie.64d78f24.mp4";